import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import iitgLogo from "../assets/iitg_logo.jpg";
import "./Footer.css";
import { db } from "../firebase";
import { ref, runTransaction, onValue } from "firebase/database";

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    const countRef = ref(db, "visitorCount");

    const visited = sessionStorage.getItem("visited");
    if (!visited) {
      sessionStorage.setItem("visited", "true");
      runTransaction(countRef, (current) => (current || 0) + 1);
    }

    const unsubscribe = onValue(countRef, (snapshot) => {
      setVisitorCount(snapshot.val() || 0);
    });

    return () => unsubscribe();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-main">
        {/* Left - Lab Info + Visitor Counter */}
        <div className="footer-left">
          <div className="footer-lab-row">
            <img src={iitgLogo} alt="IIT Guwahati Logo" className="footer-logo" />
            <div className="footer-lab-details">
              <p><b>Biomaterials &amp; Tissue Engineering Laboratory</b></p>
              <p><b>Indian Institute of Technology Guwahati</b></p>
              <p>781039, Assam, India</p>
              <p>Contact: biman.mandal@iitg.ac.in</p>
            </div>
          </div>

          {/* Visitor Counter */}
          <div className="footer-visitor">
            <span className="footer-visitor-label">Visitors</span>
            <div className="footer-visitor-digits">
              {(visitorCount ?? 0)
                .toString()
                .padStart(7, "0")
                .split("")
                .map((digit, i) => (
                  <span key={i} className="footer-visitor-digit">{digit}</span>
                ))}
            </div>
          </div>
        </div>

        {/* Right - Quick Links */}
        <div className="footer-right">
          <div className="footer-sitemap-title"><b>Quick Links</b></div>
          <ul className="footer-sitemap">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/principal-investigator">Principal Investigator</Link></li>
            <li><Link to="/members">Members</Link></li>
            <li><Link to="/alumni">Ph.D. Alumni</Link></li>
            <li><Link to="/research">Research</Link></li>
            <li><Link to="/publication">Publications</Link></li>
            <li><Link to="/patents">Patents</Link></li>
            <li><Link to="/conference">Conference</Link></li>
            <li><Link to="/news-activities">News &amp; Activities</Link></li>
            <li><Link to="/funding">Funding</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-credit">
        &copy; {new Date().getFullYear()} Biomaterials &amp; Tissue Engineering Laboratory, Indian Institute of Technology, Guwahati (IITG), India
      </div>
    </footer>
  );
};

export default Footer;